<template>
  <form class="form loginForm" @submit.prevent="onSubmit()">
    <div class="form__create-acc" v-if="createAccInfo">
      <ul v-if="typeof createAccText === 'object' && createAccText.length > 1">
        <li
          v-for="item in createAccText"
          :key="item"
          v-html="item"
        />
      </ul>
      <div v-else-if="typeof createAccText === 'object'" v-html="createAccText[0]"></div>
      <div v-else v-html="createAccText"></div>
    </div>
    <template v-else-if="hasThirdPartySSO">
      <div class="form__row form--links">
        <div class="form__get-account">
          <a href="" @click.prevent="$emit('showCreateAcc')">{{ $t('login.get_account_text') }}</a>
        </div>
        <div class="form__forgot-password">
          <a
            :href="forgetPasswordRedirect"
            @click="onForgetPasswordClick"
          >{{ $t('login.forgot_password.text') }}</a>
        </div>
      </div>
      <a :href="configUrlSSO" class="form__button" :style="{'--custom-button-bg': customButtonBg}">{{ $t('labels.enter') }}</a>
    </template>
    <template v-else-if="!hasThirdPartySSO">
      <fieldset v-if="tab==='login'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="auth"
                  :placeholder="loginInputLabel"
                  v-model="auth"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='login'
            >

          </div>
          <label class="form__label">{{ loginInputLabel }}</label>
        </div>
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
              :type="!showPassword ? 'password' : 'text'"
              name="password"
              v-model="password"
              :placeholder="$t('login.password_input.placeholder')"
              v-validate.disable="'required'"
              tabindex="2"
              v-on:input="clearErrors()"
              ref="pass"
            >
            <span class="el-input__suffix" @click="showPassword = !showPassword">
              <span class="el-input__suffix-inner">
                <i v-if="!showPassword"
                  class="el-input__icon fa fa-eye-slash"
                  aria-hidden="true"
                  :title="$t('login.password_input.show_hint')"
                />
                <i v-else
                  class="el-input__icon fa fa-eye"
                  aria-hidden="true"
                  :title="$t('login.password_input.hide_hint')"
                />
              </span>
            </span>
          </div>
          <label class="form__label">{{ $t('login.password_input.label') }}</label>
        </div>
        <div class="form__row form--links">
          <div class="form__get-account">
            <a href="/" @click.prevent="$emit('showCreateAcc')">{{ $t('login.get_account_text') }}</a>
          </div>
          <div class="form__forgot-password">
            <a
              :href="forgetPasswordRedirect"
              @click="onForgetPasswordClick"
            >{{ $t('login.forgot_password.text') }}</a>
          </div>
        </div>
        <button class="form__button" :style="{'--custom-button-bg': customButtonBg}" tabindex="3">{{ $t('labels.enter') }}</button>
        <div v-if="showCancel" @click.prevent="$emit('login-canceled')" class="form_button">{{ $t('labels.cancel') }}</div>
      </fieldset>
      <fieldset v-if="tab==='forgotPassword'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="auth"
                  :placeholder="$t('login.forgot_password.placeholder')"
                  v-model="auth"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >
          </div>
          <label class="form__label">{{ $t('login.forgot_password.orgot_password_label') }}</label>
        </div>
        <button class="form__button" :style="{'--custom-button-bg': customButtonBg}" tabindex="3" @click.prevent="sendCode">{{ $t('login.password_recover.button_text') }}</button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
      <fieldset v-if="tab==='enterCode'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="code"
                  :placeholder="$t('login.password_recover.placeholder')"
                  v-model="code"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >
          </div>
          <label class="form__label">{{ $t('login.password_recover.label') }}</label>
        </div>
        <button class="form__button" :style="{'--custom-button-bg': customButtonBg}" tabindex="3" @click.prevent="checkCode">{{ $t('login.password_recover.send_text') }}</button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
      <fieldset v-if="tab==='setPassword'">
        <div class="form__row">
          <div class="el-input">
            <password
              v-model="newPassword"
              :toggle="true"
              :placeholder="$t('login.new_password.placeholder')"
              v-validate.disable="'required'"
              v-on:input="clearErrors()"
              @passwordGenerated="onPasswordGenerated"
            ></password>
          </div>
          <label class="form__label">{{ $t('login.new_password.label') }}</label>
        </div>
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="password"
                  name="password"
                  v-model="newPasswordRepeat"
                  :placeholder="$t('login.new_password.repeat.placeholder')"
                  v-validate.disable="'required'"
                  tabindex="2"
                  v-on:input="clearErrors()"
            >
          </div>
          <label class="form__label">{{ $t('login.new_password.repeat.label') }}</label>
        </div>
        <button class="form__button" :style="{'--custom-button-bg': customButtonBg}" tabindex="3" @click.prevent="setPassword">{{ $t('login.new_password.repeat.button_text') }}</button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
    </template>
  </form>
</template>

<script>
  import auth from 'src/services/auth'
  // import localStorageTransport from 'src/services/localStorageTransport'
  import Password from './PasswordInput'
  import axios from 'axios'
  import {
    CONF_BASE_URL,
    CONF_FORGET_PASSWORD_REDIRECT,
    CONF_LOGIN_INPUT_LABEL,
    CONF_THIRD_PARTY_SSO,
    CONF_URL_SSO,
    CUSTOM_LOGIN_PAGE
  } from '@/constants'
  import config from '@/config'
  import {getCheckedLang, setCheckedLang} from '@/services/langStorage';

  export default {
    name: 'Authenticate',
    components: {Password},
    data () {
      return {
        auth: '',
        password: '',
        tab: 'login',
        code: '',
        newPassword: '',
        newPasswordRepeat: '',
        showPassword: false,
        baseUrl: config(CONF_BASE_URL),
        forgetPasswordRedirect: config(CONF_FORGET_PASSWORD_REDIRECT) || ''
      }
    },
    props: [
      'showCancel',
      'createAccInfo',
      'createAccText'
    ],
    computed: {
      customLoginPage () {
        return config(CUSTOM_LOGIN_PAGE);
      },
      customButtonBg () {
        if (this.customLoginPage && this.customLoginPage.FORM_BUTTON_BACKGROUND) {
          return this.customLoginPage.FORM_BUTTON_BACKGROUND;
        }

        return null;
      },
      hasThirdPartySSO () {
        return config(CONF_THIRD_PARTY_SSO) === true && this.configUrlSSO;
      },
      configUrlSSO () {
        return config(CONF_URL_SSO);
      },
      loginInputLabel () {
        const langUpper = this.$store.state.lang.toUpperCase();
        const configLoginInputLabel = config(CONF_LOGIN_INPUT_LABEL);

        if (configLoginInputLabel) {
          return configLoginInputLabel[langUpper] ? configLoginInputLabel[langUpper] : configLoginInputLabel.EN
        }

        return this.$t('login.login_input.placeholder')
      }
    },
    methods: {
      onForgetPasswordClick (e) {
        if (!this.forgetPasswordRedirect) {
          this.$emit('showForgotPassword');
          e.preventDefault();
        }
      },
      showCreateAcc () {
        this.$emit('showCreateAcc')
      },
      isAuthPhone () {
        let phoneReg = /^[+0-9-()\s]{10,}$/;
        let normilizeNumber = this.normalizePhone(this.auth);

        if (phoneReg.test(this.auth)) {
          if (this.auth.charAt(0) === '+') {
            return '+' + normilizeNumber;
          } else if (normilizeNumber.length >= 10) {
            if (normilizeNumber.charAt(0) === '7') {
              return '+' + normilizeNumber;
            } else if (normilizeNumber.charAt(0) === '8') {
              return '+7' + normilizeNumber.substring(1);
            } else {
              return '+7' + normilizeNumber;
            }
          } else {
            return this.auth;
          }
        } else {
          return this.auth
        }
      },
      normalizePhone (number) {
        return number.replace(/[^0-9]/gim, '')
      },
      onPasswordGenerated (newPass) {
        this.newPassword = newPass
        this.newPasswordRepeat = newPass
      },
      async setPassword () {
        // try {
        //   this.$emit('hideError')
        //   if (!this.code || this.code.length !== 6) {
        //     this.$emit('getError', this.$t('login.check_recover_code'))
        //   } else if (!this.newPassword) {
        //     this.$emit('getError', this.$t('login.enter_new_password'))
        //   } else if (this.newPassword !== this.newPasswordRepeat) {
        //     this.$emit('getError', this.$t('login.passwords_not_match'))
        //   } else {
        //     await this.$store.dispatch('users/setPasswordByCode', {
        //       code: this.code,
        //       password: this.newPassword,
        //       email: this.auth
        //     })
        //     this.tab = 'login'
        //     this.code = ''
        //     this.newPassword = ''
        //     this.newPasswordRepeat = ''
        //     this.$emit('passwordChanged')
        //   }
        // } catch (e) {
        //   if (e.response && e.response.data && e.response.data.error.code === 'E_FAILED') {
        //     this.$emit('getError', this.$t('login.wrong_or_overdue_code'))
        //   } else {
        //     this.$emit('getError', this.$t('login.unknown_error_try_later'))
        //   }
        // }
      },
      async checkCode () {
        // try {
        //   this.$emit('hideError')
        //   if (!this.code || this.code.length !== 6) {
        //     this.$emit('getError', this.$t('login.check_recover_code'))
        //   } else {
        //     await this.$store.dispatch('users/setPasswordByCode', {
        //       code: this.code,
        //       email: this.auth
        //     })
        //     this.tab = 'setPassword'
        //     this.newPassword = ''
        //     this.newPasswordRepeat = ''
        //   }
        // } catch (e) {
        //   if (e.response && e.response.data && e.response.data.error.code === 'E_FAILED') {
        //     this.$emit('getError', this.$t('login.wrong_or_overdue_code'))
        //   } else {
        //     this.$emit('getError', this.$t('login.unknown_error_try_later'))
        //   }
        // }
      },
      async sendCode () {
        // try {
        //   await this.$store.dispatch('users/sendResetPasswordCode', this.auth)
        //   this.tab = 'enterCode'
        //   this.$emit('hideError')
        //   this.code = ''
        //   this.newPassword = ''
        //   this.newPasswordRepeat = ''
        //   this.$emit('recoveryCodeSended')
        // } catch (e) {
        //   if (e.response && e.response.data && e.response.data.error.code === 'E_PARAM') {
        //     this.$emit('getError', this.$('login.check_email'))
        //   } else if (e.response && e.response.data && e.response.data.error.code === 'E_NOT_FOUND') {
        //     this.$emit('getError', this.$('login.no_user_with_this_email'))
        //   } else if (e.response && e.response.data && e.response.data.error.code === 'E_TOO_MANY_REQUESTS') {
        //     this.$emit('getError', this.$('login.too_often_send_code'))
        //   } else {
        //     this.$emit('getError', this.$t('login.unknown_error_try_later'))
        //   }
        // }
      },
      showForgotPassword () {
        this.tab = 'forgotPassword'
        this.$emit('hideError')
      },
      showLogin () {
        this.tab = 'login'
        this.password = ''
        this.$emit('hideError')
      },
      onSubmit () {
        this.$validator.validate().then(result => {
          if (result) {
            this.login()
          } else {
            this.getError()
          }
        })
      },
      getError () {
        this.$emit('getError', this.errors.items[0].msg)
      },
      clearErrors () {
        this.$validator.reset();
        this.$emit('hideError')
      },
      login () {
        const vm = this
        const urlParams = new URL(location.href).searchParams;
        const login = this.$refs.login.value
        const password = this.$refs.pass.value
        const client_id = urlParams.get('client_id') ? urlParams.get('client_id') : 'lsnuser'
        const client_secret = 'bbRW6GZ68tNe'
        const redirect_uri = urlParams.get('redirect_uri') ? urlParams.get('redirect_uri') : vm.baseUrl+'/openid/authorize'
        const url = vm.baseUrl+'/openid/authorize'
        const dataState = urlParams.get('state') ? urlParams.get('state') : 'test'
        const params = { login, password, client_id, redirect_uri, state: dataState }
        const hasParams = (!!urlParams.get('client_id') && !!urlParams.get('redirect_uri') && !!urlParams.get('state'));
        const langChecked = getCheckedLang();

        if (langChecked) {
          params.lang = langChecked;
        }

        vm.$emit('hideError');

        axios
          .post(url, params)
          .then(function (response) {
            const resp = response.data
            const responseCode = resp.code
            const responseState = resp.state
            const responseRedirect_uri = resp.redirect_uri
            const paramsForToken = { code: responseCode, client_id, client_secret, state: responseState }

            if (hasParams) {
              window.location.href = `${responseRedirect_uri}?code=${responseCode}&state=${responseState}`
              return false;
            }

            axios
              .post(vm.baseUrl+'/openid/token', paramsForToken)
              .then(function (response) {
                const access_token = response.data.access_token
                const expire = response.data.exp_ms
                const refresh_token = response.data.refresh_token

                localStorage.setItem('refresh_token', refresh_token);

                auth.logout()
                auth.setToken(access_token)

                vm.$store.dispatch('user/loadUser', true)
                  .then(function (response) {
                    const hasAnotherLang = response.data.lang;

                    if (hasAnotherLang) {
                      setCheckedLang(response.data.lang);

                      const history = JSON.parse(window.sessionStorage.getItem('vue.router.back.button.history')).history[0]
                      const isHistoryResp = history.includes('/resp/');
                      const wikiPage = sessionStorage.getItem('wikiPage');
                      const schedulePage = history.includes('/schedule/');

                      if (schedulePage) {
                        window.location.href = `#/schedule/list`
                      } else if (wikiPage) {
                        sessionStorage.removeItem('wikiPage');
                        window.location.href = `#/wiki/${wikiPage}`
                      } else if (history && isHistoryResp) {
                        window.location.href = '#' + history
                      } else if (response.data && response.data.msgr && response.data.msgr.mgs && response.data.msgr.mgs.length) {
                        window.location.href = '#/messeger/hist'
                      } else {
                        window.location.href = '#/'
                      }

                      window.location.reload();

                      return;
                    }

                    const history = JSON.parse(window.sessionStorage.getItem('vue.router.back.button.history')).history[0]
                    const isHistoryResp = history.includes('/resp/');
                    const wikiPage = sessionStorage.getItem('wikiPage');
                    const schedulePage = history.includes('/schedule/');

                    if (schedulePage) {
                      vm.$router.push(`/schedule/list`);
                    } else if (wikiPage) {
                      sessionStorage.removeItem('wikiPage');
                      vm.$router.push(`/wiki/${wikiPage}`);
                    } else if (history && isHistoryResp) {
                      vm.$router.push(history)
                    } else if (response.data && response.data.msgr && response.data.msgr.mgs && response.data.msgr.mgs.length) {
                      vm.$router.push('/messeger/hist')
                    } else {
                      vm.$router.push('/')
                    }
                  })
                  .catch(function () {
                    vm.$emit('getError', vm.$t('login.check_login_and_password'))
                  })
              })
              .catch(function () {
                vm.$emit('getError', vm.$t('login.check_login_and_password'))
              })
          })
          .catch(function () {
            vm.$emit('getError', vm.$t('login.check_login_and_password'))
          })
      },
      setFocus () {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus()
        }
      },
    },
    created () {
      if (this.$route.params.tab === 'enterCode' && this.$route.params.email) {
        this.tab = 'enterCode'
        this.auth = this.$route.params.email
      }
      if (this.$route.params.code) {
        this.code = this.$route.params.code
      }
      const vm = this;
      this.$validator.localize('ru', {
        messages: {
          required: function () {
            return vm.$t('login.all_fields_required')
          },
          email: function () {
            return vm.$t('login.wrong_email_format')
          }
        }
      });
    },
    mounted () {
      this.setFocus()
      if (this.$route.params.code) {
        this.checkCode()
      }
    }
  }
</script>

<style lang="scss">
@import 'src/assets/sass/core';

  .form__create-acc {
    font-size: 16px;
    color: #909399;

    ul {
      padding-left: 20px;

      li + li {
        margin-top: 15px;
      }
    }

    a {
      color: #ff5d2b;
      text-decoration: underline;

      &:hover {
        color: #ff5d2b;
        text-decoration: none;
      }
    }
  }
  .loginForm {
    .form--links {
      text-align: center;
      margin-top: -4px;
      flex-direction: column;
      padding-bottom: 16px;

      @include respond-to(phone-s, min) {
        flex-direction: row;
        justify-content: space-between;
        .form__get-account {
          margin-bottom: 0;
        }
      }
      .form__get-account {
        margin-bottom: 13px;
        padding-top: 0;
      }
    }
    .el-input__inner:hover {
      border-color: rgba(146, 145, 153, 1);
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #ff3948;
    }
    .form__forgot-password, .form__get-account {
      a {
        text-decoration: underline;
        border: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .cancelForgot {
      margin-top: 15px;
      color: #ACACAC;
      display: block;
      text-align: center;
      cursor: pointer;
      a {
        border-bottom: 1px solid #ACACAC;
      }
    }
    .Password {
      &__badge {
        box-sizing: content-box;
        width: auto;
      }
      &__strength-meter {
        margin-bottom: 5px;
      }
    }
    .form {
      &__button {
        text-align: center;
        border-radius: 9px;
        background: var(--custom-button-bg, linear-gradient(89.46deg, #FF3948 -44.58%, #FFAD37 158.4%));
        font-size: 14px;
        font-weight: normal;
        padding-bottom: 13px;
        &:hover {
          box-shadow: 0px 2px 15px -3px var(--custom-button-bg, rgb(255, 112, 65)), inset 0px 2px 15px 3px rgba(255, 255, 255, 0.0);
          color: #fff;
        }
        &:active {
          box-shadow: 0px 2px 15px -3px rgba(255, 255, 255, .0), inset 0px 2px 15px 3px rgba(255, 255, 255, 0.2);
        }
        &--entery {
          margin-top: 1px;
        }

        span {
          color: #fff;
        }
      }
    }
  }
</style>